import React from "react";
import "./styles.scss";

export default ({ userType }) => {
  const openUploadModal = () => {
    const uploadBtn = document.getElementById("upload-modal-btn");
    uploadBtn.click();
  };
  return (
    <>
      <div className="dashboard-overlay" />
      <div className="welcome-message">
        <div className="header text-center">
          <h1 className="py-4">WELCOME TO UNIFI MUSIC, WE’RE EXCITED YOU’RE HERE!</h1>
        </div>
        <div className="content text-left">
          <p className="mb-4">
            To start seeing useful stats that will guide your journey as
            {userType === "artist" ? " an " : " a "}
            {userType} here on UNIFI Music,{" "}
            <span className="text-secondary cursor-pointer bold" onClick={openUploadModal}>
              add some releases here
            </span>
            , or click on the
            <b className="px-1 bold">UPLOAD</b>button in the left column to get started.
          </p>
          <p className="mb-3">
            Once your friends, fans, and fellow Artists in the UNIFI Music community start listening to your new releases, this Dashboard will show
            you which are the most played, most shared, most liked, and who your top listeners are. You’ll also be able to see what areas of the world
            are tuned in.
          </p>
          <p className="mb-3">Pretty cool, right?</p>
          <p>
            Still got questions? Hit up our support team in the chat bubble at the bottom right and we’ll be happy to help.{" "}
            <span role="img" aria-label="smily-face">
              😁✌
            </span>
          </p>
        </div>
      </div>
    </>
  );
};
